import type { SocialListeningRun } from "src/services/SocialListeningAPIs";

/** "Sapphire vs Khaddi, Generation" for competitive runs, the brand alone otherwise. */
export const getRunTitle = (run: Pick<SocialListeningRun, "company_name" | "competitors">): string =>
  run.competitors.length
    ? `${run.company_name} vs ${run.competitors.join(", ")}`
    : run.company_name;

export const formatReportDate = (
  value: string | null | undefined,
  locale: string,
  atLabel?: string
): string => {
  if (!value) {return "";}
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {return "";}

  const datePart = date.toLocaleDateString(locale, { year: "numeric", month: "long", day: "numeric" });
  if (!atLabel) {return datePart;}

  const timePart = date.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit", hour12: true });
  return `${datePart} ${atLabel} ${timePart}`;
};
